import {Injectable} from '@angular/core';
import {AmdocsAppsyncClientService} from 'amdocs-core-package';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';


@Injectable()
export class MetaDataService {
  constructor( private appSyncClient: AmdocsAppsyncClientService) {
  }

  getDocumentMetaData(documentId,apsSessionId,sessionContextInput?): Observable<any> {
  const metaDataQuery = `query GetDocumentMetaDataById($apsSessionId: String!,$documentId:String!,$sessionContextInput: SessionContextInput) {
      getDocumentMetaDataById(apsSessionId: $apsSessionId, documentId: $documentId,sessionContextInput: $sessionContextInput) {
        errorMessage
    expires
    nonHtmlDocumentUrl
    fusionDoumentResponse {
      results {
        groupField
        list {
          hits
          maxScore
          docs {
            collection
            groupValue
            id
            type
            fields {
              APrdctTre
              DocCert
              DocDt
              DocNum
              DocTyp
              FVN
              KII
              KIN
              KIT
              LstUpdt
              PL
              PermsSts
              Prdct
              SNPT
              SPUrl
              SRC
              UnqI
              VR
              VSK
            }
          }
        }
      }
    }
      }
    }
  `;
    const paramsvalues = {
      apsSessionId,
      documentId,
      sessionContextInput: sessionContextInput ? sessionContextInput : null
    };
    return this.appSyncClient.call(metaDataQuery, 'GetDocumentMetaDataById', paramsvalues).pipe(
        mergeMap( (res: any): Observable<any> => {
          return of(res);
        }),
        catchError( err => {
          console.log(err);
          return of({error: err});
        })
    );
  }

  getDocumentInternalSearchData(documentId, searchKey,sessionContextInput?): Observable<any> {

    const metaDataQuery = `query GetDocumentById($documentId:String!,$searchKey: String,$sessionContextInput:SessionContextInput) {
       getDocumentById( documentId: $documentId, searchKey:$searchKey,sessionContextInput: $sessionContextInput) {
         errorMessage
     expires
     fusionDoumentResponse {
       results {
         groupField
         list {
           hits
           maxScore
           docs {
             collection
             groupValue
             id
             type
             fields {
               SNPT
               SPUrl
               UnqI
               VSK
             }
             highlights {
               KIN {
                 value
               }
               SNPT{
                 value
               }
             }
           }
           pagination {
             start
           }
         }
       }
     }
       }
     }
 `;
    const paramsvalues = {
      documentId,
      searchKey,
      sessionContextInput: sessionContextInput ? sessionContextInput : null
    };
    return this.appSyncClient.call(metaDataQuery, 'GetDocumentById', paramsvalues).pipe(
      mergeMap((res: any): Observable<any> => {
        return of(res);
      }),
      catchError(err => {
        console.log(err);
        return of({ error: err });
      })
    );
  }

}
